import { render } from "./StudentAttendanceContent.vue?vue&type=template&id=4c7973c0&ts=true"
import script from "./StudentAttendanceContent.vue?vue&type=script&lang=ts"
export * from "./StudentAttendanceContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__